import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { setFilters } from 'components/ApiTable/model/commands/setFilters';
import { initializeSimpleFilters } from './initializeSimpleFilters';
import { reloadTableData } from './reloadTableData';

export const submitAdvancedFilters: ApiTableCommandFactory =
  (cmdContext, dispatch) => () => {
    const {
      advancedFilter: { filters },
    } = cmdContext.getState();

    if (filters === undefined) {
      return;
    }

    // clean up simple filters UI
    dispatch(initializeSimpleFilters, { initialFilters: {} });

    dispatch(setFilters, { filters, origin: 'advanced' });

    dispatch(reloadTableData);
  };
